import { render } from "./CityPageSkeleton.vue?vue&type=template&id=c702e6b6&scoped=true"
import script from "./CityPageSkeleton.vue?vue&type=script&lang=js"
export * from "./CityPageSkeleton.vue?vue&type=script&lang=js"

import "./CityPageSkeleton.vue?vue&type=style&index=0&id=c702e6b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c702e6b6"]])

export default __exports__